var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.remaining > 0)?_c('div',{staticClass:"subtitle-2 minimum-purchase"},[_vm._v(" "+_vm._s(_vm.$t("checkout.minimumPurchase", [_vm.$n(_vm.remaining, "currency")]))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }